<div class="container-fluid">
    <div>
        <div class="row margin-top-8">
            <div class="header" *ngIf="editing == false">
                {{ "bikeshop.thirdparty.add_edit.property.title_create" | translate }}
            </div>
            <div class="header" *ngIf="editing == true">
                {{ "bikeshop.thirdparty.add_edit.property.title_edit" | translate }}
            </div>
        </div>
        <div class="row margin-top-8 info-container content">
            <div class="col-md-12">

                <form [formGroup]="thirdPartyForm">

                    <div class="row margin-top-8">
                        <div class="col-md-4 label">
                            *{{ "bikeshop.thirdparty.add_edit.property.name" | translate }}:
                        </div>
                        <div class="col-md-8 value">
                            <input type="text" formControlName="name" pInputText placeholder="Enter Third Party Name"/>
                        </div>
                    </div>


                    <div class="row margin-top-8">
                        <div class="col-md-4 label">
                            *{{ "bikeshop.thirdparty.add_edit.property.contactname" | translate }}:
                        </div>
                        <div class="col-md-8 value">
                            <input type="text" pInputText formControlName="contactName"
                                   placeholder="Person to contact name details"/>
                        </div>
                    </div>

                    <div class="row margin-top-8">
                        <div class="col-md-4 label">
                            {{ "bikeshop.thirdparty.add_edit.property.phonenumber" | translate }}:
                        </div>
                        <div class="col-md-8 value">
                            <input type="text" pInputText formControlName="phoneNumber" placeholder="Phone Number"/>
                        </div>
                    </div>

                    <div class="row margin-top-8">
                        <div class="col-md-4 label">
                            {{ "bikeshop.thirdparty.add_edit.property.address" | translate }}:
                        </div>
                        <div class="col-md-8 value">
                            <textarea pInputTextarea [rows]="5" formControlName="address"
                                      placeholder="Physical Address"></textarea>
                        </div>
                    </div>

                    <div class="row margin-top-8">
                        <div class="col-md-4 label">
                            {{ "bikeshop.thirdparty.add_edit.property.image.label" | translate }}:
                        </div>
                        <div class="col-md-8 value">
                            <div *ngIf="imagePreview != null" class="primary-image margin-top-16"
                                 [ngStyle]="{'background-image': 'url( ' +imagePreview +'), linear-gradient(0deg, white 0%, white 100%)'}">
                            </div>

                            <div class="row margin-top-16">
                                <div *ngIf="imagePreview !== null" class="col-md-6">
                                    <button pButton class="p-button full-width"
                                            label="{{'bikeshop.thirdparty.add_edit.property.image.action.remove' | translate}}"
                                            [disabled]="uploadingLogoImage"
                                            (click)="removeImageUrl()"></button>
                                </div>

                                <div [class.col-md-12]="imagePreview === null" [class.col-md-6]="imagePreview !== null">
                                    <button pButton class="p-button full-width"
                                            label="{{'bikeshop.thirdparty.add_edit.property.image.action.upload' | translate}}"
                                            [disabled]="uploadingLogoImage"
                                            (click)="primaryUpload.click()"></button>
                                </div>
                            </div>

                            <input #primaryUpload type="file" style="display: none" (change)="imageUploader($event)">

                        </div>
                    </div>

                    <hr>

                    <!-- <div class="row margin-top-16">
                      <div class="col-md-12">
                        <div class="sub-header">{{ "bikeshop.thirdparty.add_edit.heading.servicetypes" | translate }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 label margin-top-0">
                        <small>{{ "bikeshop.thirdparty.add_edit.subheading.servicetypes" | translate }}</small>
                      </div>
                    </div>

                    <div class="row margin-top-8">
                      <div class="col-md-4 label">
                        {{ "bikeshop.thirdparty.add_edit.property.servicetypes" | translate }}:
                      </div>
                      <div class="col-md-8 value">
                        <p-multiSelect #serviceTypeDropDown
                        [options]="serviceTypes"
                        [formControlName]="'selectedServiceTypes'"
                        [filter]="true"
                        filterBy="search,reverseSearch"
                        scrollHeight="450px"
                        resetFilterOnHide="true"
                        autofocus="true"
                        [showToggleAll]="false"
                        defaultLabel="Choose">
                        </p-multiSelect>
                        <small>
                          {{ "bikeshop.thirdparty.add_edit.subheading.helpertext" | translate }}
                        </small>
                      </div>
                    </div>

                    <div class="row margin-top-8">
                      <div class="col-md-4 label">
                        {{ "bikeshop.thirdparty.add_edit.property.responsibleforpayment" | translate }}:
                      </div>
                      <div class="col-md-8 value">
                        <p-inputSwitch
                        title="Customer"
                        [formControlName]="'responsibleForPayment'"
                        >
                          </p-inputSwitch>
                      </div>
                    </div>

                    <hr> -->

                    <div class="row margin-top-16">
                        <div class="col-md-12">
                            <div class="sub-header">{{ "bikeshop.thirdparty.add_edit.heading.notify" | translate }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 label margin-top-0">
                            <small>{{ "bikeshop.thirdparty.add_edit.subheading.notify" | translate }}</small>
                        </div>
                    </div>

                    <div class="row margin-top-8">
                        <div class="col-md-4 label">
                            *{{ "bikeshop.thirdparty.add_edit.property.emails" | translate }}:
                        </div>
                        <div class="col-md-8 value">
                            <input type="text" pInputText formControlName="notifyEmails"
                                   placeholder="tom@3rdparty.com,lucy@3rdparty.com"/>
                            <small>{{ "bikeshop.thirdparty.add_edit.property.emailshelper" | translate }}</small>
                        </div>
                    </div>

                    <div *ngFor="let status of statusList; let i = index" class="margin-top-16"
                         style="margin-bottom: 24px;">
                        <div class="row" style="margin-bottom: 16px;">
                            <div class="col-md-4 label">
                                {{ status.label }}:
                            </div>
                            <div class="col-md-4">
                                <p-checkbox [ngModelOptions]="{standalone: true}" name="customerGroup"
                                            [value]="status.key"
                                            [(ngModel)]="selectedStatusListValues[i].customer" [binary]="true"
                                            label="Customer"></p-checkbox>
                            </div>
                            <div class="col-md-4">
                                <p-checkbox [ngModelOptions]="{standalone: true}" name="thirdPartyGroup"
                                            [value]="status.key"
                                            [(ngModel)]="selectedStatusListValues[i].thirdParty" [binary]="true"
                                            label="{{ thirdPartyForm.get('name').value ? thirdPartyForm.get('name').value : 'Third-Party' }}"></p-checkbox>
                            </div>
                        </div>
                    </div>

                    <div class="margin-top-8 button-container" style="display: flex; justify-content: space-between;">
                        <div style="display: flex;">
                            <div *ngIf="editing" style="margin-right: 20px;">
                                <button *ngIf="!deleteLoading" pButton
                                        label="{{'bikeshop.thirdparty.add_edit.action.delete' | translate}}"
                                        class="p-button-raised alternate" (click)="deleteThirdParty()"
                                        [disabled]="saveLoading"
                                        style="width: 200px;"></button>
                                <div *ngIf="deleteLoading">
                                    <p-progressSpinner [style]="{ width: '30px', height: '30px' }"
                                                       animationDuration=".5s">
                                    </p-progressSpinner>
                                </div>
                            </div>
                        </div>
                        <button *ngIf="!saveLoading" pButton (click)="checkSave()" class="p-button-raised"
                                label="{{'bikeshop.thirdparty.add_edit.action.save' | translate}}"
                                [disabled]="deleteLoading"
                                style="width: 200px;"></button>
                        <div *ngIf="saveLoading">
                            <p-progressSpinner [style]="{ width: '30px', height: '30px' }"
                                               animationDuration=".5s"></p-progressSpinner>
                        </div>
                    </div>

                </form>

            </div>
        </div>
    </div>
</div>
